<div [formGroup]="formGroup">
	<div class="field-row label-width-50 align-items-center">
		<div class="field-row-title">
			Hub Model
		</div>
		<div class="field-row-element">
			<mat-form-field subscriptSizing="dynamic">
				<mat-select formControlName="avlModel"
							[errorStateMatcher]="InstantErrorStateMatcherInstance">
					@for (model of allAvlModels; track model.id) {
						<mat-option [value]="model.id">{{ model.name }}</mat-option>
					}
				</mat-select>
				@if (formGroup.controls.avlModel.hasError('required')) {
					<mat-error>AVL model is required</mat-error>
				}
			</mat-form-field>
		</div>
	</div>

	@if (formGroup.controls.avlModel.value === AvlModel.PLOWOPS_PROHUB) {
		<div class="field-row label-width-50 align-items-center">
			<div class="field-row-title">
				Pro hub serial number
			</div>
			<div class="field-row-element">
				<mat-form-field subscriptSizing="dynamic" matAutocompleteOrigin #origin="matAutocompleteOrigin">
					<input matInput
						   autocomplete="off"
						   type="text"
						   [errorStateMatcher]="InstantErrorStateMatcherInstance"
						   [matAutocomplete]="proHubSerialAutocomplete"
						   [matAutocompleteConnectedTo]="origin"
						   (input)="proHubSerialChanged($event)"
						   formControlName="proHubSerial">
					@if (formGroup.controls.proHubSerial.hasError('required')) {
						<mat-error>Serial number is required</mat-error>
					}
				</mat-form-field>
				<mat-autocomplete
          #proHubSerialAutocomplete="matAutocomplete"
          class="imei-autocomplete"
          requireSelection
        >
					@if (proHubSerialValuesLoading) {
						<mat-option class="text-muted" disabled>loading...</mat-option>
					} @else {
						@if (availableProHubSerialOptions.length) {
							@for(o of availableProHubSerialOptions; track o.id) {
								<mat-option [value]="o.lmuId">{{o.lmuId}}</mat-option>
							}
							@if (hasMoreProHubSerialOptions) {
                <div
                  class="mat-mdc-option load-more-option"
                  (mousedown)="$event.preventDefault()"
                  (click)="loadMoreProHubSerialOptions($event)"
                >
                  Load more...
                </div>
							}
						} @else {
							<mat-option disabled>serial number not found</mat-option>
						}
					}
				</mat-autocomplete>
			</div>
		</div>
    } @else if (formGroup.controls.avlModel.value !== AvlModel.NONE && formGroup.controls.avlModel.value !== AvlModel.PLOWOPS_HUB_C) {
		<div class="field-row label-width-50 align-items-center">
			<div class="field-row-title">
				LMU Id
			</div>
			<div class="field-row-element">
				<mat-form-field subscriptSizing="dynamic">
					<input matInput
						   autocomplete="off"
						   type="text"
						   [errorStateMatcher]="InstantErrorStateMatcherInstance"
						   (input)="proHubSerialChanged($event)"
						   formControlName="lmuId">
					@if (formGroup.controls.lmuId.pending) {
						<mat-progress-spinner diameter="20" mode="indeterminate" matSuffix>check</mat-progress-spinner>
					}
					@if (formGroup.controls.lmuId.hasError('required')) {
						<mat-error>LMU Id is required</mat-error>
					}
					@if (formGroup.controls.lmuId.hasError('notUnique')) {
						<mat-error>LMU Id is already used.</mat-error>
					}
				</mat-form-field>
			</div>
		</div>
	}
</div>
<div class="field-row label-width-50 align-items-center">
	<div class="field-row-title">
		Hardware
	</div>
	<div class="field-row-element">
		<button mat-stroked-button
				[disabled]="formGroup.invalid || formGroup.pending"
				(click)="addVehicleHardware()">
			Add
		</button>
	</div>
</div>

<mat-nav-list>
	<mat-menu #menuHardware="matMenu">
		<ng-template matMenuContent let-hardware="hardware" let-type="type">
      @if (type !== ListItemType.CAMERA) {
        <button mat-menu-item
                (click)="editHardware(type, hardware)">
          Edit Hardware
        </button>
      }
			<button mat-menu-item
					(click)="removeHardware(type, hardware)">
				Remove Hardware
			</button>
		</ng-template>
	</mat-menu>

	@if (vcu.cameraConfiguration) {
		<mat-list-item (click)="editHardware(ListItemType.CAMERA)">
			<div matListItemTitle>
				Camera
			</div>
			<div matListItemMeta>
				<button mat-icon-button
						(click)="$event.stopPropagation()"
						[matMenuTriggerFor]="menuHardware"
						[matMenuTriggerData]="{type: ListItemType.CAMERA}">
					<mat-icon>more_vert</mat-icon>
				</button>
			</div>
		</mat-list-item>
		@if (vcu.digitalSpreader || vcu.additionalHardware.length) {
			<mat-divider></mat-divider>
		}
	}
	@if (vcu.digitalSpreader) {
		<mat-list-item (click)="editHardware(ListItemType.DIGITAL_SPREADER)">
			<div matListItemTitle>
				Digital Spreader ({{vcu.digitalSpreader.model}})
			</div>
			<div matListItemMeta>
				<button mat-icon-button
						(click)="$event.stopPropagation()"
						[matMenuTriggerFor]="menuHardware"
						[matMenuTriggerData]="{type: ListItemType.DIGITAL_SPREADER}">
					<mat-icon>more_vert</mat-icon>
				</button>
			</div>
		</mat-list-item>
		@if (vcu.additionalHardware.length) {
			<mat-divider></mat-divider>
		}
	}
	@for (hardware of vcu.additionalHardware; track $index) {
		<mat-list-item (click)="editHardware(ListItemType.OTHER, $index)">
			<div matListItemTitle>
				{{vehicleHardwareTypeLabels[hardware.type]}}
				@if (hardware.type === VehicleHardwareType.PLOW) {
					@if (hardware.plowConfiguration?.label) {
						- {{hardware.plowConfiguration.label}}
					}
					@if (hardware.plowConfiguration?.twoWireOtherConnection) {
						(Two wire)
					}
				} @else {

				}
			</div>
			<div matListItemMeta>
				<button mat-icon-button
						(click)="$event.stopPropagation()"
						[matMenuTriggerFor]="menuHardware"
						[matMenuTriggerData]="{type: ListItemType.OTHER, hardware: $index}">
					<mat-icon>more_vert</mat-icon>
				</button>
			</div>
		</mat-list-item>
		@if (!$last) {
			<mat-divider></mat-divider>
		}
	}
</mat-nav-list>
